import qs from 'qs';
import { SearchForRetail } from '@/client/api';
import { ccApi } from './ccApi';
import { CC_API_TAGS } from './constants';
const INSIGHTS_CACHE_TTL_SECONDS = 300;
export const actionableInsightsApi = ccApi.injectEndpoints({
    endpoints: (builder) => ({
        getActionableInsightData: builder.query({
            query: ({ areaId, filters }) => {
                const queryString = qs.stringify(Object.assign({ areaId }, filters), { arrayFormat: 'comma' });
                return {
                    url: `/${SearchForRetail.ANALYTICS_PATH}/actionableInsights?${queryString}`,
                    method: 'GET',
                };
            },
            transformResponse: (response) => {
                var _a, _b;
                return ((_b = (_a = response === null || response === void 0 ? void 0 : response.actionableInsights) === null || _a === void 0 ? void 0 : _a.filter(({ show, actionableInsightType }) => show && actionableInsightType)) !== null && _b !== void 0 ? _b : []);
            },
            providesTags: [CC_API_TAGS.ActionableInsight],
            keepUnusedDataFor: INSIGHTS_CACHE_TTL_SECONDS,
        }),
    }),
});
export const { useGetActionableInsightDataQuery } = actionableInsightsApi;
